import { cityApi } from 'service/api'
import { to } from 'nh-utils'
import isPreRendering from 'utils/isPreRendering'

export const getLocalities = () => !isPreRendering() && to(cityApi.get('/city'))
